import PackageModal from 'components/packages/modals/PackageModal'
import TimelineNode from 'components/packages/TimelineNode'
import { closePackageModal } from 'lib/openPackageModal'
import React from 'react'

const COMPLETE_STEPS = [
  {
    label: 'Send acknowledgment of complete application package to applicant',
    dot: 'var(--dark-green)',
    dotSize: 7,
    text: 'dome-color-lite-grey',
  },
  {
    label: 'Share application package with board members',
    dot: 'var(--sage)',
    dotSize: 8,
    text: 'dome-color-darkest-grey',
  },
]

const CONNECTOR_COLUMN = { width: 20, alignItems: 'center', flexShrink: 0 }

function StepMarker({ idx, label, nodeColor, textClass, last }) {
  const edgeColor = idx === 0 ? 'var(--sage)' : 'var(--lite-grey)'

  return (
    <>
      <TimelineNode
        key={idx}
        label={label}
        nodeColor={nodeColor}
        edgeColor={edgeColor}
        textClass={textClass}
        isLast={last}
      />
    </>
  )
}

function CompleteBody() {
  return (
    <ul
      className="dome-d-flex dome-flex-column dome-gap0"
      style={{
        margin: 0,
        padding: '12px 0',
        listStyle: 'none',
        borderTop: '1px solid var(--accent)',
        borderBottom: '1px solid var(--accent)',
      }}
    >
      {COMPLETE_STEPS.map((step, idx) => (
        <StepMarker
          idx={idx}
          label={step.label}
          nodeColor={step.dot}
          textClass={step.text}
          last={idx === COMPLETE_STEPS.length - 1}
        />
      ))}
    </ul>
  )
}

function IncompleteBody() {
  return (
    <span className="dome-p1 dome-color-dark-grey">
      Your summary has been successfully sent to the applicant. Requirements are locked until the applicant resubmits.
    </span>
  )
}

export default function SummarySentModal({ packageHashedId, complete = false }) {
  const goToStatus = () => {
    window.location.href = `/packages/${packageHashedId}/status`
  }
  const goToShareTab = () => {
    window.location.href = `/packages/${packageHashedId}/board_members`
  }

  const footer = complete ? (
    <div className="dome-d-flex dome-justify-between">
      <button type="button" onClick={goToStatus} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
        go to status
      </button>
      <button type="button" onClick={goToShareTab} className="dome-btn dome-btn-base dome-btn-dark-green">
        go to share tab
      </button>
    </div>
  ) : (
    <div className="dome-d-flex dome-justify-between">
      <button
        type="button"
        onClick={closePackageModal}
        className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
      >
        back to requirements
      </button>
      <button type="button" onClick={goToStatus} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
        go to status
      </button>
    </div>
  )

  return (
    <PackageModal isOpen onClose={closePackageModal}>
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-d-flex dome-flex-column dome-gap12">
          <span>
            <i style={{ fontSize: '42px' }} className="fa-thin fa-circle-check dome-color-dark-green" />
          </span>
          <span className="dome-h2 dome-color-dark-green">summary sent</span>
          <span className="dome-p1 dome-color-dark-grey">This application package has been updated.</span>
        </div>
        {complete ? <CompleteBody /> : <IncompleteBody />}
        {footer}
      </div>
    </PackageModal>
  )
}
